import { createAction } from '@reduxjs/toolkit';

import {
  ACCOUNT_SIGN_OUT_FAILURE,
  ACCOUNT_SIGN_OUT_REQUEST,
  ACCOUNT_SIGN_OUT_SUCCESS,
} from '@app/store/actionTypes';

export function signOut() {
  return {
    type: ACCOUNT_SIGN_OUT_REQUEST,
  };
}

export const signOutSuccess = createAction(ACCOUNT_SIGN_OUT_SUCCESS);

export function signOutFailure() {
  return {
    type: ACCOUNT_SIGN_OUT_FAILURE,
  };
}

export type AccountSignOutAction =
  | ReturnType<typeof signOut>
  | ReturnType<typeof signOutSuccess>
  | ReturnType<typeof signOutFailure>;
